import React, { useState } from 'react'
import HeaderWrapper from "../../components/common/HeaderWrapper";
import {predictModels} from "../../utils/DataModals"
import  AllModals from './Models/AllModels';
import ActiveModals from "./Models/ActiveModels";
import InactiveModals from "./Models/InactiveModels";
import { useNavigate } from 'react-router-dom' 
import { SearchIcon } from '../../components/common/IconComponents';
import CustomButton from '../../components/common/CustomButton';

const Models = () => {

    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const handleSearch = (event) => {
      const inputText = event.target.value;
      const sanitizedText = inputText.replace(/\s/g, ''); // Remove spaces from the input text
      setSearchQuery(sanitizedText);
    };  

    const handleTabClick=(tabIndex)=>{
      setActiveTab(tabIndex);
    }

    //filter data based on the active tab and search text
    let filteredData;
    if(activeTab === 1){
      filteredData = predictModels.filter((model) =>
      model.Name.toLowerCase().includes(searchQuery.toLowerCase())

      ) ;
    }else if(activeTab === 2 ){
      filteredData = predictModels.filter((model) =>
      model.Status=== 'Active' &&
      model.Name.toLowerCase().includes(searchQuery.toLowerCase())

    )
  
  }if(activeTab === 3){
    filteredData = predictModels.filter((model) =>
    model.Status === 'Inactive' &&
    model.Name.toLowerCase().includes(searchQuery.toLowerCase())
  )
}

    const activeModals = predictModels.filter((model) => model.Status === "Active");
    const inactiveModals = predictModels.filter((model) => model.Status === "Inactive");


  return (
    <div>
     
      <HeaderWrapper>
          <div className='flex justify-between items-center  w-full'>
            <div className='flex items-center'>
              <h1 className='font-medium text-xl xl:mr-6 sm:-mr-2'>Models</h1>
              <div className="relative ml-6 sm:mr-3">
                  <input type='text'
                    value={searchQuery}
                    id='seach' 
                    role='search' 
                    placeholder='Search' 
                    className='xl:w-[520px] md:w-[400px] sm:w-45 xl:py-1 xl:pl-8 xl:pr-4 sm:pr-2 sm:pl-4 border-0 rounded-3xl bg-gray-50'
                    onChange={handleSearch}
                  />
                  <span className="absolute inset-y-0 left-0 pl-1 flex items-center pointer-events-none">
                      <SearchIcon className="text-gray-500" />
                  </span>
              </div>               
              
            </div>     

            <span className='xl:mr-6 sm:mr-2'>
                <CustomButton 
                  className='xl:px-5 md:px-2 lg:px-3 xl:py-2 sm:p-0.5' 
                  onClick={()=>navigate('/CreateModelStep1')}>
                  Create Model
                </CustomButton>
            </span>
          </div>
      </HeaderWrapper>
  
      {/* models tab */}
      <div className='mx-6 mb-4'>
        <ul className='flex gap-4'>
          <li>
            <button  id='all-tab' className={`px-1 ${activeTab === 1 ? "border-b-2 border-solid border-blue-400" : "text-gray-400"}`}
              onClick={() => handleTabClick(1)}>
              All ({predictModels.length})
            </button>
          </li>

          <li>
            <button className={`px-1 ${activeTab === 2 ? "border-b-2 border-solid border-blue-400" : "text-gray-400"}`}
              onClick={() => handleTabClick(2)}>
              Active ({activeModals.length})
            </button>
          </li>

          <li>
            <button className={`px-1 ${activeTab === 3 ? "border-b-2 border-solid border-blue-400" : "text-gray-400"}`}
              onClick={() => handleTabClick(3)}>
              Inactive ({inactiveModals.length})
            </button>
          </li>

        </ul>
      </div>

      {/* models tab content */}
      <div className='px-6'>
        <div id='all' >
            {activeTab === 1 && <AllModals filteredData={filteredData}/>}
            {activeTab === 2 && <ActiveModals filteredData={filteredData}/>}
            {activeTab === 3 && <InactiveModals filteredData={filteredData}/>}
        </div>
      </div>
      
    </div>
  );
}

export default Models